"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mating Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.37
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PregnancyTestApi = exports.PregnancyTestApiFactory = exports.PregnancyTestApiFp = exports.PregnancyTestApiAxiosParamCreator = exports.InterventionApi = exports.InterventionApiFactory = exports.InterventionApiFp = exports.InterventionApiAxiosParamCreator = exports.InterventionTypeEnum = exports.InterventionEventUpdateTypeEnum = exports.CowPregnancyTestResultUpdateTypeEnum = exports.CowPregnancyTestResultTypeEnum = exports.CowPregnancyDiagnosisSourceEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * Origin of the pregnancy diagnosis
 * @export
 * @enum {string}
 */
exports.CowPregnancyDiagnosisSourceEnum = {
    MINDA: 'MINDA'
};
/**
 * The result of the pregnancy test
 * @export
 * @enum {string}
 */
exports.CowPregnancyTestResultTypeEnum = {
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE',
    DOUBTFUL: 'DOUBTFUL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowPregnancyTestResultUpdateTypeEnum = {
    CREATED: 'Created',
    ATTRIBUTE_UPDATE: 'AttributeUpdate',
    REMOVED: 'Removed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.InterventionEventUpdateTypeEnum = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE'
};
/**
 * Type of hormone treatment applied to the cattle
 * @export
 * @enum {string}
 */
exports.InterventionTypeEnum = {
    PG: 'PG',
    CIDR: 'CIDR',
    OTHER: 'OTHER'
};
/**
 * InterventionApi - axios parameter creator
 * @export
 */
var InterventionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Bulk record hormone treatment for a group of cattle
         * @param {IBulkCreateInterventionDTO} [iBulkCreateInterventionDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateInterventions: function (iBulkCreateInterventionDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/mating/intervention/bulk-create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iBulkCreateInterventionDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete intervention by id
         * @param {string} interventionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntervention: function (interventionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'interventionId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteIntervention', 'interventionId', interventionId);
                    localVarPath = "/mating/intervention/delete/{interventionId}"
                        .replace("{".concat("interventionId", "}"), encodeURIComponent(String(interventionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets all treatments that have been given to the cow for all time
         * @param {string} cattleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterventionsForCow: function (cattleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleId' is not null or undefined
                    (0, common_1.assertParamExists)('getInterventionsForCow', 'cattleId', cattleId);
                    localVarPath = "/mating/intervention/get-for-cow";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets all treatments that have been given to all cattle in the season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterventionsForSeason: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('getInterventionsForSeason', 'seasonId', seasonId);
                    localVarPath = "/mating/intervention/get-for-season";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (seasonId !== undefined) {
                        localVarQueryParameter['seasonId'] = seasonId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.InterventionApiAxiosParamCreator = InterventionApiAxiosParamCreator;
/**
 * InterventionApi - functional programming interface
 * @export
 */
var InterventionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InterventionApiAxiosParamCreator)(configuration);
    return {
        /**
         * Bulk record hormone treatment for a group of cattle
         * @param {IBulkCreateInterventionDTO} [iBulkCreateInterventionDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateInterventions: function (iBulkCreateInterventionDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkCreateInterventions(iBulkCreateInterventionDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete intervention by id
         * @param {string} interventionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntervention: function (interventionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteIntervention(interventionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets all treatments that have been given to the cow for all time
         * @param {string} cattleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterventionsForCow: function (cattleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInterventionsForCow(cattleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets all treatments that have been given to all cattle in the season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterventionsForSeason: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInterventionsForSeason(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InterventionApiFp = InterventionApiFp;
/**
 * InterventionApi - factory interface
 * @export
 */
var InterventionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InterventionApiFp)(configuration);
    return {
        /**
         * Bulk record hormone treatment for a group of cattle
         * @param {IBulkCreateInterventionDTO} [iBulkCreateInterventionDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateInterventions: function (iBulkCreateInterventionDTO, options) {
            return localVarFp.bulkCreateInterventions(iBulkCreateInterventionDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete intervention by id
         * @param {string} interventionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntervention: function (interventionId, options) {
            return localVarFp.deleteIntervention(interventionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets all treatments that have been given to the cow for all time
         * @param {string} cattleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterventionsForCow: function (cattleId, options) {
            return localVarFp.getInterventionsForCow(cattleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets all treatments that have been given to all cattle in the season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterventionsForSeason: function (seasonId, options) {
            return localVarFp.getInterventionsForSeason(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InterventionApiFactory = InterventionApiFactory;
/**
 * InterventionApi - object-oriented interface
 * @export
 * @class InterventionApi
 * @extends {BaseAPI}
 */
var InterventionApi = /** @class */ (function (_super) {
    __extends(InterventionApi, _super);
    function InterventionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Bulk record hormone treatment for a group of cattle
     * @param {IBulkCreateInterventionDTO} [iBulkCreateInterventionDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionApi
     */
    InterventionApi.prototype.bulkCreateInterventions = function (iBulkCreateInterventionDTO, options) {
        var _this = this;
        return (0, exports.InterventionApiFp)(this.configuration).bulkCreateInterventions(iBulkCreateInterventionDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete intervention by id
     * @param {string} interventionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionApi
     */
    InterventionApi.prototype.deleteIntervention = function (interventionId, options) {
        var _this = this;
        return (0, exports.InterventionApiFp)(this.configuration).deleteIntervention(interventionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets all treatments that have been given to the cow for all time
     * @param {string} cattleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionApi
     */
    InterventionApi.prototype.getInterventionsForCow = function (cattleId, options) {
        var _this = this;
        return (0, exports.InterventionApiFp)(this.configuration).getInterventionsForCow(cattleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets all treatments that have been given to all cattle in the season
     * @param {string} seasonId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionApi
     */
    InterventionApi.prototype.getInterventionsForSeason = function (seasonId, options) {
        var _this = this;
        return (0, exports.InterventionApiFp)(this.configuration).getInterventionsForSeason(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InterventionApi;
}(base_1.BaseAPI));
exports.InterventionApi = InterventionApi;
/**
 * PregnancyTestApi - axios parameter creator
 * @export
 */
var PregnancyTestApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * bulk ingest pregnancy test results
         * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCowPregnancyTestResultBatch: function (iCreateCowPregnancyTestResultBatchDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateCowPregnancyTestResultBatchDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createCowPregnancyTestResultBatch', 'iCreateCowPregnancyTestResultBatchDTO', iCreateCowPregnancyTestResultBatchDTO);
                    localVarPath = "/mating/pregnancy-test";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCowPregnancyTestResultBatchDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a pregnancy test
         * @param {string} pregnancyTestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePregnancyTest: function (pregnancyTestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pregnancyTestId' is not null or undefined
                    (0, common_1.assertParamExists)('deletePregnancyTest', 'pregnancyTestId', pregnancyTestId);
                    localVarPath = "/mating/pregnancy-test/{pregnancyTestId}"
                        .replace("{".concat("pregnancyTestId", "}"), encodeURIComponent(String(pregnancyTestId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Fetch pregnancy test results
         * @param {string} [cattleId]
         * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
         * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPregnancyTestResults: function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/mating/pregnancy-test";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    if (diagnosisDateAfter !== undefined) {
                        localVarQueryParameter['diagnosisDateAfter'] = (diagnosisDateAfter instanceof Date) ?
                            diagnosisDateAfter.toISOString() :
                            diagnosisDateAfter;
                    }
                    if (diagnosisDateBefore !== undefined) {
                        localVarQueryParameter['diagnosisDateBefore'] = (diagnosisDateBefore instanceof Date) ?
                            diagnosisDateBefore.toISOString() :
                            diagnosisDateBefore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PregnancyTestApiAxiosParamCreator = PregnancyTestApiAxiosParamCreator;
/**
 * PregnancyTestApi - functional programming interface
 * @export
 */
var PregnancyTestApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PregnancyTestApiAxiosParamCreator)(configuration);
    return {
        /**
         * bulk ingest pregnancy test results
         * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCowPregnancyTestResultBatch: function (iCreateCowPregnancyTestResultBatchDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCowPregnancyTestResultBatch(iCreateCowPregnancyTestResultBatchDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a pregnancy test
         * @param {string} pregnancyTestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePregnancyTest: function (pregnancyTestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePregnancyTest(pregnancyTestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Fetch pregnancy test results
         * @param {string} [cattleId]
         * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
         * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPregnancyTestResults: function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findPregnancyTestResults(cattleId, diagnosisDateAfter, diagnosisDateBefore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PregnancyTestApiFp = PregnancyTestApiFp;
/**
 * PregnancyTestApi - factory interface
 * @export
 */
var PregnancyTestApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PregnancyTestApiFp)(configuration);
    return {
        /**
         * bulk ingest pregnancy test results
         * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCowPregnancyTestResultBatch: function (iCreateCowPregnancyTestResultBatchDTO, options) {
            return localVarFp.createCowPregnancyTestResultBatch(iCreateCowPregnancyTestResultBatchDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a pregnancy test
         * @param {string} pregnancyTestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePregnancyTest: function (pregnancyTestId, options) {
            return localVarFp.deletePregnancyTest(pregnancyTestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Fetch pregnancy test results
         * @param {string} [cattleId]
         * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
         * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPregnancyTestResults: function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
            return localVarFp.findPregnancyTestResults(cattleId, diagnosisDateAfter, diagnosisDateBefore, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PregnancyTestApiFactory = PregnancyTestApiFactory;
/**
 * PregnancyTestApi - object-oriented interface
 * @export
 * @class PregnancyTestApi
 * @extends {BaseAPI}
 */
var PregnancyTestApi = /** @class */ (function (_super) {
    __extends(PregnancyTestApi, _super);
    function PregnancyTestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * bulk ingest pregnancy test results
     * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PregnancyTestApi
     */
    PregnancyTestApi.prototype.createCowPregnancyTestResultBatch = function (iCreateCowPregnancyTestResultBatchDTO, options) {
        var _this = this;
        return (0, exports.PregnancyTestApiFp)(this.configuration).createCowPregnancyTestResultBatch(iCreateCowPregnancyTestResultBatchDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a pregnancy test
     * @param {string} pregnancyTestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PregnancyTestApi
     */
    PregnancyTestApi.prototype.deletePregnancyTest = function (pregnancyTestId, options) {
        var _this = this;
        return (0, exports.PregnancyTestApiFp)(this.configuration).deletePregnancyTest(pregnancyTestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Fetch pregnancy test results
     * @param {string} [cattleId]
     * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
     * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PregnancyTestApi
     */
    PregnancyTestApi.prototype.findPregnancyTestResults = function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
        var _this = this;
        return (0, exports.PregnancyTestApiFp)(this.configuration).findPregnancyTestResults(cattleId, diagnosisDateAfter, diagnosisDateBefore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PregnancyTestApi;
}(base_1.BaseAPI));
exports.PregnancyTestApi = PregnancyTestApi;
